var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { HistoryAnswers } from './modules/HistoryAnswers';
import { HistoryDbMicroAnswers } from './modules/HistoryDbMicroAnswers';
import { HistoryRecentAnswers } from './modules/HistoryRecentAnswers';
export class TrayHistory {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get tray() {
        return this.parent;
    }
    get app() {
        return this.tray.app;
    }
    get historyRecentAnswers() {
        return new HistoryRecentAnswers(this);
    }
    get historyDbMicroAnswers() {
        return new HistoryDbMicroAnswers(this);
    }
    get historyAnswers() {
        return new HistoryAnswers(this);
    }
}
__decorate([
    memoize
], TrayHistory.prototype, "historyRecentAnswers", null);
__decorate([
    memoize
], TrayHistory.prototype, "historyDbMicroAnswers", null);
__decorate([
    memoize
], TrayHistory.prototype, "historyAnswers", null);
